// ** React Imports
/* eslint-disable  */
import { lazy } from "react";

// const Login = lazy(() => import("../../views/pages/authentication/Login"));

const RegisterMultiSteps = lazy(() =>
  import("../../views/pages/authentication/register-multi-steps")
);

const ResetPasswordCover = lazy(() =>
  import("../../views/pages/authentication/ResetPasswordCover")
);
const ForgotPassword = lazy(() =>
  import("../../views/pages/authentication/ForgotPassword")
);
const AuthenticationRoutes = [
  {
    path: "/login",
    element: <RegisterMultiSteps />,
    meta: {
      layout: "blank",
      publicRoute: true,
      restricted: true,
    },
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
    layout: "BlankLayout",
    meta: {
      layout: "blank",
      publicRoute: true,
      restricted: true,
    },
  },
  {
    path: "/forgetpass/:token",
    element: <ResetPasswordCover />,
    meta: {
      action: "read",
      resource: "ACL",
      // menuHidden: true,
      layout: "blank",
      publicRoute: true,
    },
  },
];

export default AuthenticationRoutes;
